import EcoImg from 'eco-design/base/eco-img';
import { AnimatedGrid } from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from 'eco-design-reliance/getLocal';

const Automotive: React.FC = () => {
    const { t } = useLang('Automotive');
    const { locale = 'us' } = getLocal();
    const isEu = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale);
    return (
        <div className={`${styles.Automotive}  ${isEu ? 'range5' : ""} GtmModuleData-section`} data-section-id="d3c-Automotive" id="LFP">
            <EcoImg
                className="bg"
                isOpenLazy={true}
                pc="https://websiteoss.ecoflow.com/upload/image/1774857695432/PC-1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1774857696734/M-1.jpg"
            />
            <div className="d3m-layout ">
                <div className="text-wrapper">
                    <CommonTitle title={t('title')} desc={t('desc')} />
                    <AnimatedGrid variant="rotateIn" options={{ delay: 200, stagger: 0.15, threshold: 0.2 }} className="list-wrapper">
                        <div className="list-item">
                            <div className="list-item-title">{t('list1_title')}</div>
                            <div className="list-item-desc">
                                {t.rich('list1_desc', {
                                    sup: (text: string) => <sup>{text}</sup>,
                                })}
                            </div>
                        </div>
                        <div className="list-item">
                            <div className="list-item-title">{t('list2_title')}</div>
                            <div className="list-item-desc">
                                {t.rich('list2_desc', {
                                    sup: (text: string) => <sup>{text}</sup>,
                                })}
                            </div>

                        </div>

                    </AnimatedGrid>
                    {/* {t('btn') && <div className="list-item-btn">{t('btn')} <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <rect width="20" height="20" rx="10" fill="#3F68E0" />
                        <path d="M7.5 5L12.5 10L7.5 15" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></div>} */}
                </div>
            </div>
        </div>
    );
};

export default Automotive;
